<div class="row flex-between-center border my-2">
  <div class="col-auto my-2">
    <labeled-content [label]="'general.name'">
      <label class="data-labels">{{ namePositionEmailData().name }}</label>
    </labeled-content>
  </div>
  <div class="col-auto my-2">
    <labeled-content [label]="'general.position'">
      <label class="data-labels">{{ namePositionEmailData().position }}</label>
    </labeled-content>
  </div>
  <div class="col-auto my-2">
    <labeled-content [label]="'general.email'">
      <label class="data-labels">{{ namePositionEmailData().email }}</label>
    </labeled-content>
  </div>
</div>
